"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingProgressType = void 0;
var OnboardingProgressType;
(function (OnboardingProgressType) {
    OnboardingProgressType["NotStarted"] = "NotStarted";
    OnboardingProgressType["TypeSelected"] = "TypeSelected";
    OnboardingProgressType["AccountUpdated"] = "AccountUpdated";
    OnboardingProgressType["InstitutionsAdded"] = "InstitutionsAdded";
    OnboardingProgressType["UsersInvited"] = "UsersInvited";
    OnboardingProgressType["Complete"] = "Complete";
})(OnboardingProgressType = exports.OnboardingProgressType || (exports.OnboardingProgressType = {}));
//# sourceMappingURL=onboarding-progress-type.js.map